module.exports = __webpack_public_path__ + "04_long_brown.f34b198c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/04_long_brown.png
// module id = 8L2E
// module chunks = 0